import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../../../../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../../../../ai-answer-dialog/types';

// When the user clicks "Hide answer" in the minimized loading dialog (SmartAnswerCardMinimizedLoading)
export const onAIAnswerMinimizedLoadingCollapseClicked: (
	props: commonAttributesType,
) => AnalyticsEventPayload = (props: commonAttributesType): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerMinimizedLoadingCollapseButton',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
